import { GenericPage } from "../components/common/GenericPage";
import {
  planetCollapseTableFields,
  planetTableFields,
} from "../utils/table-fields/planetTableFields";

export const AllPlanets = () => {
  return (
    <GenericPage
      title="All Planets"
      subtitle="Exploration data of known systems"
      parentQuery="allPlanets"
      childQuery="planets"
      tableFields={planetTableFields}
      collapseFields={planetCollapseTableFields}
    />
  );
};
